import { useModal } from '../contexts/Modal.context';
import Button from '../components/Button'

export default function AlertModal({ data }) {
    const { closeModal } = useModal()
    const { confirm, message, action, buttonTexts = ["Cancel", "Confirm"] } = data

    return (
        <div className="bg-gray-50 rounded-b-xl space-y-6 p-6 max-w-2xl">
            <div className="max-w-sm text-center space-y-2">
                <p className="">{`${message ?? "Please confirm this action."}`}</p>
            </div>
            <div className="flex space-x-4 justify-center">
                {
                    buttonTexts[1] ? <Button variant={actionType(action)[0]} onClick={closeModal}>{buttonTexts[0]}</Button> : null
                }
                <Button variant={actionType(action)[1]} onClick={() => {
                    confirm?.()
                    closeModal()
                }}>{buttonTexts[1] ?? buttonTexts[0]}</Button>
            </div>
        </div>
    )
}

function actionType(action) {
    switch (action) {
        case "danger":
            return ["light-blue", "solid-red"]
        case "safe":
            return ["light-blue"]
        default:
            return ["light-blue", "solid-red"]
    }
}